import { Injectable, signal } from '@angular/core';
import { Layout } from '../models/layout/layout.model';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public layout = signal<Layout>(new Layout());

  updateLayout(layout: Layout) {
    this.layout.set(layout);
  }
}
